<div class="denmalpflege-message row" *ngIf="isDenkmalpflege">
  <div class="col-12">
    <h4 class="provisorische-fassung font-weight-bold" translate>DETAIL_VIEW.DENKMAL_MELDUNG.TITLE</h4>
    <p class="provisorische-fassung font-weight-bold" translate>DETAIL_VIEW.DENKMAL_MELDUNG.MELDUNG</p>
    <p class="provisorische-fassung font-weight-bold" translate>DETAIL_VIEW.DENKMAL_MELDUNG.CONTACT</p>
  </div>
</div>
